module.exports = __webpack_public_path__ + "static/media/trimex_finatrigo_silao.2eafd697.png";